<template>
  <div>
    <div class="catSlider" :class="{'fixed': fixed}" v-if="$store.state.showCatSlider">


      <!--                <div class="d-flex bgp brandPadding">-->
      <!--                    <v-btn icon-->
      <!--                           class="mr-1"-->
      <!--                           @click.native.passive="$ebus.$emit('gotoStart')" style="flex-grow: 0; opacity: 0">-->
      <!--                        <v-icon medium class="myWhite">mdi-home</v-icon>-->
      <!--                    </v-btn>-->
      <!--                                <v-btn icon-->
      <!--                                       class="ml-1"-->
      <!--                                       @click.native.passive="$ebus.$emit('switchDrawer')" style="flex-grow: 0;">-->
      <!--                                    <v-icon medium class="myWhite">mdi-menu</v-icon>-->
      <!--                                </v-btn>-->
      <!--                    <v-spacer></v-spacer>-->
      <!--                    <div class="brandHead align-self-center">-->
      <!--                        <img src="../assets/placeholder6-opti.svg"-->
      <!--                             @click.passive="$ebus.$emit('gotoStart')"-->
      <!--                        >-->
      <!--                    </div>-->
      <!--                    <v-spacer></v-spacer>-->
      <!--&lt;!&ndash;                    v-if="itemsCount > 0"&ndash;&gt;-->
      <!--                    <v-badge-->
      <!--                            color="#EDCD66"-->
      <!--                            :content="itemsCount"-->
      <!--                            overlap-->
      <!--                            offset-x="20"-->
      <!--                            offset-y="20"-->
      <!--                            class="cart animated"-->
      <!--                    >-->
      <!--                        <v-btn icon @click.native.passive="gotoCart">-->
      <!--                            <v-icon medium class="myWhite">mdi-cart</v-icon>-->
      <!--                        </v-btn>-->
      <!--                    </v-badge>-->
      <!--                </div>-->

      <!--        <div class="d-flex bgp brandPadding">-->
      <!--            <v-btn icon-->
      <!--                   class="ml-1"-->
      <!--                   @click.native.passive="$ebus.$emit('switchDrawer')" style="flex-grow: 0;">-->
      <!--                <v-icon medium class="myWhite">mdi-menu</v-icon>-->
      <!--            </v-btn>-->
      <!--            <v-spacer></v-spacer>-->
      <!--            <div class="brandHead align-self-center">-->
      <!--                <img src="../assets/Logo-Gotti-rosa.svg"-->
      <!--                     @click.passive="$ebus.$emit('gotoStart')"-->
      <!--                >-->
      <!--            </div>-->
      <!--            <v-spacer></v-spacer>-->
      <!--            <v-btn icon-->
      <!--                   class="mr-1"-->
      <!--                   @click.native.passive="$ebus.$emit('gotoStart')" style="flex-grow: 0; opacity: 0">-->
      <!--                <v-icon medium class="myWhite">mdi-home</v-icon>-->
      <!--            </v-btn>-->
      <!--        </div>-->
      <!--        <div class="brandHead pt-5">-->
      <!--            <img @click.left="$ebus.$emit('gotoStart')" src="../assets/Logo-Gotti-rosa.svg">-->
      <!--        </div>-->
      <!--        <div class="pt-2 bgp"></div>-->
      <v-slide-group :show-arrows="false"
                     v-model="model"
                     :center-active="true"
                     :mandatory="true"
      >
        <v-slide-item
          v-for="cat in cats"
          :key="cat.pId"
          :value="cat.pId"
          v-slot:default="{ active, toggle }"
        >
          <!--                :value="cat.id"-->
          <!--                    v-slot:default="{ active, toggle }"-->
          <div class="prelative">

            <!--                    <SliderBtn-->
            <!--                            :cat="cat"-->
            <!--                            @click.native.passive="toggle(); selectCat(cat)"-->
            <!--                    ></SliderBtn>-->

            <v-btn
              large
              tile
              class="sliderBtn titleFont text-none"
              :input-value="active"
              active-class="catActive"
              @click="toggle(); selectCat(cat)"
            >
              {{ cat.categoryDE }}
            </v-btn>

            <!--                    <div class="absTriangle"></div>-->
            <!--            <div class="absLine"></div>-->
          </div>
        </v-slide-item>
      </v-slide-group>

      <!--        <span style="display: none">{{cat}}</span>-->
      <!--        <h2>catId = {{cat.id}}</h2>-->
    </div>
  </div>
</template>

<script>
import store from '../store/store'
import {clearEvents, cloneMe} from "@/vendor/util";
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants'
// import SliderBtn from "./SliderBtn";

export default {
  name: "CatSlider",
  components: {
    // SliderBtn
  },
  // props:['cats'],
  props: {
    fixed: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      //contains the selected pId
      ivMonitor: null,
      model: null,
      cats: [
        // {
        //     id: '1',
        //     categoryDE: 'STREETFOOD',
        //     type: 'food',
        //     icon: 'streetfood.png',
        // },
        // {
        //     id: '2',
        //     categoryDE: 'BOWLS<br>& SALADS',
        //     type: 'food',
        //     icon: 'bowl.png',
        // },
        // {
        //     id: '3',
        //     categoryDE: 'SNACKS<br>& NACHOS',
        //     type: 'food',
        //     icon: 'snack.png',
        // },
        // {
        //     id: '4',
        //     categoryDE: 'SALSAS',
        //     type: 'food',
        //     icon: 'salsas.png',
        // },
        // {
        //     id: '5',
        //     categoryDE: 'KIDS/<br>SUMMER SIZE',
        //     type: 'food',
        //     icon: 'kids.png',
        // },
        // {
        //     id: '6',
        //     categoryDE: 'PLATES',
        //     type: 'food',
        //     icon: 'plates.png',
        // },
        // {
        //     id: '7',
        //     categoryDE: 'SWEETS',
        //     type: 'food',
        //     icon: 'sweets.png',
        // }
      ],
    }
  },
  computed: {
    // cat: {
    //     get() {
    //         // this.updateModel();
    //         // this.model = store.getters.selectedCategory.id;
    //         return store.getters.selectedCategory;
    //     },
    //     // set(newCat) {
    //     //     store.commit('selectedCategory', newCat);
    //     // }
    // },
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        i += item.count;
      }
      return '' + i;
    },
  },
  created() {
    ebus.$on(qconst.notify$foodsUpdated, () => {
      this.initSlider();
    });
    ebus.$on(qconst.notify$drinksUpdated, () => {
      this.initSlider();
    });
  },
  destroyed() {
    clearEvents([
      qconst.notify$foodsUpdated,
      qconst.notify$drinksUpdated
    ]);
    try {
      clearInterval(this.ivMonitor);
    } catch (e) {
    }
  },
  mounted() {
    console.log('CatSlider mounted..');
    if (this.cats.length === 0) {
      this.initSlider();
    }
    // setInterval(() => {
    //     this.lazyUpdateModel(true);
    // }, 1000);
    this.removeFirstButtonPadding();
    //Bugfix workaround https://github.com/vuetifyjs/vuetify/issues/10455
    setTimeout(() => {
      this.cats.push({id: 'dummy', categoryDE: ' '});
    }, 100);
    setTimeout(() => {
      this.cats.pop();
      // this.removeFirstButtonPadding();
    }, 200);
  },
  activated() {
    console.log('CatSlider activated..');
    this.lazyUpdateModel();
  },
  // watch: {
  //     dialog(newValue) {
  //         this.isDialog = newValue;
  //         if (newValue) {
  //             this.init();
  //         }
  //     },
  // },
  methods: {
    removeFirstButtonPadding() {
      // let e = window.document.querySelector('.sliderBtn');
      // if (e) {
      //     e.classList.add('pl-0');
      //     console.log('removeFirstButtonPadding completed');
      // }
    },
    updateModel(catpId) {
      // // setTimeout(() => {
      // // let id = '' + store.getters.selectedCategory.id;
      // if (catpId) {
      //     // id = catId;
      //     this.model = catpId;
      //     console.log('CatSlider updateModel ' + catpId);
      // }
      // // if (id && this.model !== id) {
      // //     this.model = id;
      // // }
      //
      // // }, 200);
      //
      // // setTimeout(()=>{
      // //     this.removeFirstButtonPadding();
      // // },10);
      // // setTimeout(()=>{
      // //     this.removeFirstButtonPadding();
      // // },100);
    },
    initSlider() {
      console.log('CatSlider initSlider');
      let fcats = cloneMe(store.getters.foodMenu);
      for (let fcat of fcats) {
        fcat.pId = 'food' + fcat.id;
        fcat.type = 'food';
      }
      let dcats = cloneMe(store.getters.drinkMenu);
      for (let dcat of dcats) {
        dcat.pId = 'drink' + dcat.id;
        dcat.type = 'drink';
      }
      let combinedCats = fcats.concat(dcats);
      // console.log('so do we have cats??? ' + foodCats.length);
      this.cats = cloneMe(combinedCats);
      // setTimeout(() => {

      this.lazyUpdateModel();

      this.updateModel();
      // this.model = store.getters.selectedCategory.id;
      // }, 200);
      // this.loaded = true;
      this.monitorSelectedState();
    },
    monitorSelectedState() {
      this.ivMonitor = setInterval(() => {
        if (!store.state.duringCatSelect) {
          let sc = store.getters.selectedCategory;
          if (sc.id.length > 1) {
            this.lazyUpdateModel(true);
          }
        }
      }, 800);
    },
    lazyUpdateModel(once) {
      //preselect tab after first init
      let sc = store.getters.selectedCategory;
      if (sc.id.length > 1) {
        let pId = sc.type === 'food' ? 'food' + sc.id : 'drink' + sc.id;
        if (this.model !== pId) {
          this.model = pId;
        }
        // console.log('!!!!!!!!!! model = ' + sc.categoryDE+' pId = '+pId);
      } else {
        // if (!once) {
        //selects the tab after a reload of the page
        if (!once) {
          //retry
          setTimeout(() => {
            // console.log('retry lazyUpdateMode');
            this.lazyUpdateModel();
          }, 800);
        }
      }
    },
    selectCat(c) {
      //prevent navigation if the selected cat is the currently selected cat
      if (this.$route.name !== 'Home') {
        let sc = store.getters.selectedCategory;
        if (sc.id === c.id && sc === c.type) {
          console.log('selectCat: prevent double navigation');
          return;
        }
      }

      // if (store.state.duringCatSelect) {
      //     console.log('!!!!!!!!!! selectCat: duringCatSelect = true');
      //
      //     return;
      // }
      store.state.duringCatSelect = true;
      console.log('selectCat: ================ duringCatSelect = true');
      setTimeout(() => {
        store.state.duringCatSelect = false;
        console.log('selectCat: ================ duringCatSelect completed');
      }, 600);

      console.log('selectCat: ' + c.categoryDE + ' ' + c.id + ' type ' + c.type);


      // if (c.id === '1') {
      //     ebus.$emit('goto', {name: 'Streetfood'})
      // } else if (c.id === '2') {
      //     ebus.$emit('goto', {name: 'Bowls'})
      // } else if (c.id === '3') {
      //     ebus.$emit('goto', {name: 'Snacks'})
      // } else if (c.id === '4') {
      //     ebus.$emit('goto', {name: 'Salsas'})
      //     // this.$router.push({name: 'SpeisenProdukte', params: {catname: 'Salsas'}});
      // } else if (c.id === '5') {
      //     ebus.$emit('goto', {name: 'SummerSize'})
      // } else if (c.id === '6') {
      //     this.$router.push({name: 'SpeisenProdukte', params: {catname: 'Plates'}});
      // } else if (c.id === '7') {
      //     this.$router.push({name: 'SpeisenProdukte', params: {catname: 'Sweets'}});
      // }


      let cat = cloneMe(c);
      if (cat.type) {
        this.updateModel(cat.pId);
        store.commit('selectedCategory', cat);

        if (cat.type === 'drink') {
          this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
        } else if (cat.type === 'food') {
          this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
        }
      }

      // this.$emit('selectCat', cat);
    },
    // gotoCart() {
    //     if (this.$route.name === 'Korb') {
    //         ebus.$emit('toast', 'Du befindest dich bereits im Warenkorb');
    //     } else {
    //         this.$router.push({name: 'Korb'});
    //     }
    //
    // },
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.sliderBtn {
  border-radius: $box-border-radius;
  margin: 0 2px;
  padding: 0 12px !important;
  //border-left: 1px solid white;
  //color: white;
  //font-size: 1.05em;
  //
  //&:before {
  //  opacity: 0 !important;
  //}
}

.catSlider ::v-deep .catActive {
  background-color: $color-primary !important;
  //border: 2px solid $color-primary;
  color: white !important;
  border-radius: $box-border-radius;

  &::before {
    opacity: 0;
  }

  //text-decoration: underline;
}

.catSlider {
  width: 100%;
  height: 44px;
  background: transparent;
  color: $font-color;
  //background-color: $color-hover;
  //background-color: #FDFBFA;
  z-index: 35;

  &.fixed {
    position: fixed;
    top: 0; //$headHeight;
    left: 0;
  }

  //button.sliderBtn.v-btn.v-btn--contained.v-btn--tile {
  //  background: transparent;
  //  color: $font-color;
  //  height: 44px;
  //  //color: #333333;
  //}

  /*<!--&.catActive {-->*/
  /*<!--    button.sliderBtn.v-btn.v-btn&#45;&#45;contained.v-btn&#45;&#45;tile {-->*/
  /*<!--        color: $accent;-->*/
  /*<!--    }-->*/
  /*<!--}-->*/
}

/*.catSlider ::v-deep .v-btn__content{*/
/*    font-weight: 500;*/
/*}*/

.catSlider ::v-deep .v-slide-group__next, .v-slide-group__prev {
  min-width: 40px;
  flex: 0 1 40px;
  background-color: transparent;
}

.catSlider ::v-deep .v-slide-group__next {
  &.v-slide-group__next--disabled {
    background: none;
  }

  i {
    color: $color-primary;
  }
}

.catSlider ::v-deep .v-slide-group__prev {
  &.v-slide-group__prev--disabled {
    background: none;
  }

  i {
    color: $color-primary;
  }
}

.catSlider ::v-deep .v-slide-group__wrapper {
  /*!*overflow: inherit; //this orevents the slider to work propperly*!*/
  overflow-y: visible !important;
  contain: initial;
  border-radius: 13px;
  /*height: 50px;*/
}

.catSlider ::v-deep .v-slide-item--active .absTriangle {
  visibility: visible;
}

.brandPadding {
  padding: 10px;
}

.absTriangle {
  pointer-events: none;
  visibility: hidden;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 55px;
  /*width: 0;*/
  /*height: 0;*/
  width: 15px;
  height: 15px;
  /*<!--background-color: $accent;-->*/
  border-width: 15px 12.5px 0 12.5px;
  border-color: $color-primary transparent transparent transparent;
  border-style: solid;
}


.absLine {
  position: absolute;
  right: 0;
  top: 18px;
  height: 18px;
  width: 1px;
  background-color: white;
}

.brandHead {
  height: 40px;
  text-align: center;

  img {
    display: inline-block;
    height: 100%;
    width: auto;
  }
}

/*<!--.brandHead {-->*/
/*<!--    background-color: $color-primary;-->*/
/*<!--    height: 48px;-->*/
/*<!--    text-align: center;-->*/

/*<!--    img {-->*/
/*<!--        display: inline-block;-->*/
/*<!--        height: 100%;-->*/
/*<!--        width: auto;-->*/
/*<!--    }-->*/
/*<!--}-->*/

.theme--light .catSlider ::v-deep .v-icon.v-icon--disabled {
  color: $color-primary !important;
}

/*.catSlider ::v-deep .v-slide-group {*/
/*    !*<!--background-color: $color-primary;-->*!*/
/*    background-color: transparent;*/
/*}*/

///////////////
/*.catSlider {*/
/*    //border-bottom: 1px solid #ccc;*/

/*    //.v-slide-group {*/
/*    //  margin-bottom: -1px;*/
/*    //}*/

/*    !*<!--.v-slide-group__next {-->*!*/
/*    !*<!--    background-color: transparent;-->*!*/
/*    */
/*    !*<!--    &.v-slide-group__next&#45;&#45;disabled {-->*!*/
/*    !*<!--        background: none;-->*!*/
/*    !*<!--    }-->*!*/
/*    */
/*    !*<!--    i {-->*!*/
/*    !*<!--        color: $color-primary;-->*!*/
/*    !*<!--    }-->*!*/
/*    !*<!--}-->*!*/

/*    !*.v-slide-group__prev {*!*/
/*    !*    background-color: transparent;*!*/
/*    */
/*    !*    &.v-slide-group__prev--disabled {*!*/
/*    !*        background: none;*!*/
/*    !*    }*!*/
/*    */
/*    */
/*    !*    i {*!*/
/*    !*        color: #808080;*!*/
/*    !*    }*!*/
/*    !*}*!*/

/*    //.sliderBtn {*/
/*    //  font-size: 14px;*/
/*    //  height: 70px !important;*/
/*    //  //border-right: 1px solid $color-gray;*/
/*    //  background-color: $accent !important;*/
/*    //  color: $color-primary;*/
/*    //}*/
/*    //*/
/*    //.sliderBtn:before {*/
/*    //  opacity: 0 !important;*/
/*    //}*/

/*    .catActive {*/
/*        //background-color: black !important;*/
/*        //color: white;*/
/*        //text-decoration: underline;*/
/*    }*/
/*}*/


</style>
